import React from 'react';
import { Route } from 'react-router-dom';
import BhiAdminRoute from 'src/routes/BhiAdminRoute';
import { AdminSignupPage, AdminSignupsPage } from '../pages/admin';

export const routes = (
  <>
    <Route
      path="/admin/signups"
      element={
        <BhiAdminRoute>
          <AdminSignupsPage />
        </BhiAdminRoute>
      }
    />
    <Route
      path="/admin/signups/:signupId"
      element={
        <BhiAdminRoute>
          <AdminSignupPage />
        </BhiAdminRoute>
      }
    />
  </>
);
